import { Modal as AntdModal, ModalProps as AntdModalProps } from 'antd';
import { CSSProperties, FC, useMemo } from 'react';

const FULL_SCREEN_WIDTH = '93dvw';
const FULL_SCREEN_HEIGHT = '93dvh';

interface ModalProps extends AntdModalProps {
  fullScreen?: boolean;
}

const FULL_SCREEN_STYLES: Record<string, CSSProperties> = {
  container: {
    height: FULL_SCREEN_HEIGHT,
    display: 'flex',
    flexDirection: 'column',
  },
  body: {
    flex: 1,
    height: '100%',
    minHeight: 0,
    overflow: 'auto',
    padding: '1rem',
  },
  header: { paddingInline: '1rem' },
};

const Modal: FC<ModalProps> = ({ fullScreen, styles, width, ...props }) => {
  const mergedStyles = useMemo<AntdModalProps['styles']>(() => {
    if (!fullScreen) return styles;
    if (typeof styles === 'function') {
      return (info) => {
        const result = styles(info);
        return {
          ...result,
          container: { ...FULL_SCREEN_STYLES.container, ...result?.container },
          body: { ...FULL_SCREEN_STYLES.body, ...result?.body },
          header: { ...FULL_SCREEN_STYLES.header, ...result?.header },
        };
      };
    }
    return {
      ...styles,
      container: { ...FULL_SCREEN_STYLES.container, ...styles?.container },
      body: { ...FULL_SCREEN_STYLES.body, ...styles?.body },
      header: { ...FULL_SCREEN_STYLES.header, ...styles?.header },
    };
  }, [fullScreen, styles]);

  return (
    <AntdModal
      destroyOnHidden
      centered
      {...props}
      width={fullScreen ? FULL_SCREEN_WIDTH : width}
      styles={mergedStyles}
    />
  );
};

Modal.displayName = 'Modal';

export { Modal };
